<template>
    <div class="user_menu2">
        <div class="user_menu_div1">
            <div class="wp1">
                <div class="ic">
                    <img src="@/assets/image/order_ic3.png" />
                </div>
                <span>个人中心</span>
            </div>

            <div class="de_content_box2">
                <div class="user_menu_list">
                    <div class="item" :class="{ 'active': $route.path == '/user' }" @click="open('/user')">基本资料</div>
                    <div class="item" :class="{ 'active': $route.path == '/editpass' }" @click="open('/editpass')">修改密码
                    </div>
                    <div class="item" :class="{ 'active': $route.path == '/shiming' }" @click="open('/shiming')">实名认证
                    </div>
                    <div class="item" :class="{ 'active': $route.path == '/money' || $route.path == '/withdraw' }"
                        @click="open('/money')">资金明细</div>
                    <div class="item" @click="open('/logout')">退出登录</div>
                </div>
            </div>

        </div>
        <!-- <div class="user_menu_div1">
            <div class="wp1">
                <div class="ic"></div>
                <span>我是买家</span>
            </div>
            <div class="user_menu_list">
                <div class="item" @click="open('/shiming')">我的租赁订单</div>
            </div>
        </div>
        <div class="user_menu_div1">
            <div class="wp1">
                <div class="ic"></div>
                <span>我是卖家</span>
            </div>
            <div class="user_menu_list">
                <div class="item" @click="open('/shiming')">我的出租订单</div>
            </div>
        </div> -->
    </div>
</template>
<script>
export default {
    props: {},
    components: {},
    data() {
        return {

        }
    },
    computed: {




    },
    watch: {


    },
    created() {

    },
    methods: {
        open(item) {

            if (item == '/logout') {
                localStorage.removeItem('usertoken')
                sessionStorage.removeItem('usertoken')
                this.$store.commit('SET_userinfo', {})
                this.$store.commit('SET_login', false)
                this.$router.push("/")
            } else {

                console.log(item)
                this.$router.push(item)
            }
        },
        logout() {
            localStorage.removeItem('usertoken')
            sessionStorage.removeItem('usertoken')
            this.$store.commit('SET_userinfo', {})
            this.$store.commit('SET_login', false)
            this.$router.push("/")
        }

    },
}
</script>
